import React, { memo, useCallback } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, oneOfType, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function AcquiredModelCard({ id, title, thumbnailUrl, viewerCompatible, isSelected, onSelect }) {
  const t = useTranslation()

  const handleClick = useCallback(() => onSelect(id), [onSelect, id])

  const label = viewerCompatible
    ? t('threeDModelPicker.cardLabel', { title })
    : t('threeDModelPicker.cardUnsupportedLabel', { title })

  return (
    <button
      type="button"
      className={classnames(
        'three-d-model-picker__card',
        isSelected && 'three-d-model-picker__card--selected',
      )}
      onClick={handleClick}
      disabled={!viewerCompatible}
      aria-pressed={isSelected}
      aria-label={label}
      title={title}
    >
      <img className="three-d-model-picker__card-image" src={thumbnailUrl} alt="" draggable={false} />
    </button>
  )
}

AcquiredModelCard.propTypes = {
  id: oneOfType([number, string]).isRequired,
  title: string.isRequired,
  thumbnailUrl: string.isRequired,
  viewerCompatible: bool.isRequired,
  isSelected: bool.isRequired,
  onSelect: func.isRequired,
}

export default memo(AcquiredModelCard)
